import { BaseModalV2 } from 'components/ui/BaseModal'
import React, { useRef } from 'react'
import useLocaleText from 'components/useLocaleText'
import { ModalHeader } from '../commonUI/Modal/ModalHeader'
import { ModalFooter } from '../commonUI/Modal/ModalFooter'
import { CampaignModalProps, FormRef } from 'redux/actions/campaigns'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { CampaignForm } from './Form/CampaignForm'

const CampaignModal = ({ isOpen, onClose, onRequestClose, onCreated, campaign }: CampaignModalProps) => {
  const modal_title = useLocaleText('create_competition', true)
  const admin_submit_button = useLocaleText('admin_submit_button')
  const { isCampaignCreating } = useSelector((state: RootState) => state.campaigns)

  const formRef = useRef<FormRef>(null)

  const handleSubmitClick = () => {
    formRef.current?.submit()
  }

  return (
    <BaseModalV2
      isOpen={isOpen}
      onClose={onClose}
      header={<ModalHeader title={modal_title} onClose={onRequestClose} />}
      body={<CampaignForm ref={formRef} onClose={onClose} onCreated={onCreated} campaign={campaign} />}
      footer={
        <ModalFooter isLoading={isCampaignCreating} onSubmit={handleSubmitClick} buttonText={admin_submit_button} />
      }
      modalContentProps={{
        w: '100%',
        maxW: { base: '90vw', md: '80vw', lg: '800px' },
        minW: '350px',
      }}
      modalBodyProps={{
        height: 'auto',
        minH: '50vh',
        maxH: { base: '80dvh', md: '70dvh' },
        opacity: isCampaignCreating ? 0.5 : 1,
        pointerEvents: isCampaignCreating ? 'none' : 'auto',
      }}
      modalHeaderProps={{
        boxShadow: 'none',
        opacity: isCampaignCreating ? 0.5 : 1,
        pointerEvents: isCampaignCreating ? 'none' : 'auto',
      }}
    />
  )
}

export default CampaignModal
